<template>
  <div class="image-manager">
    <h2>{{isLogo ? 'ロゴ' : 'イメージ'}}<span>{{currentSize}} MB / {{planSize}} MB</span></h2>
    <div class="sub-header">
      <div
        v-if="!isLogo"
        class="sort normal-btn"
        @click="isShowSortSelect = !isShowSortSelect"
        v-on-clickaway="sortSelectAway"
      >
        並び替え
        <transition>
          <ul class="sort-option drop-down-list" v-show="isShowSortSelect">
            <li :class="{ selected: sort.index === 0 }" @click="changeSort(0, 'code', 'asc')">ID昇順</li>
            <li :class="{ selected: sort.index === 1 }" @click="changeSort(1, 'code', 'desc')">ID降順</li>
            <li :class="{ selected: sort.index === 2 }" @click="changeSort(2, 'name', 'asc')">名前昇順</li>
            <li :class="{ selected: sort.index === 3 }" @click="changeSort(3, 'name', 'desc')">名前降順</li>
            <li :class="{ selected: sort.index === 4 }" @click="changeSort(4, 'modifiedUserName', 'asc')">更新者名昇順</li>
            <li :class="{ selected: sort.index === 5 }" @click="changeSort(5, 'modifiedUserName', 'desc')">更新者名降順</li>
            <li :class="{ selected: sort.index === 6 }" @click="changeSort(6, 'modifiedOn', 'asc')">更新日時昇順</li>
            <li :class="{ selected: sort.index === 7 }" @click="changeSort(7, 'modifiedOn', 'desc')">更新日時降順</li>
            <li :class="{ selected: sort.index === 8 }" @click="changeSort(8, 'size', 'asc')">サイズ昇順</li>
            <li :class="{ selected: sort.index === 9 }" @click="changeSort(9, 'size', 'desc')">サイズ降順</li>
          </ul>
        </transition>
      </div>
      <div v-if="!isCallByEditor" class="display-type normal-btn" :class="viewMode === 'tile' ? 'list' : 'tile'" @click="changeViewMode">
        {{ viewMode === 'tile' ? 'リスト' : 'タイル' }}表示
      </div>
      <div v-if="!isLogo" class="search">
        <input
          type="text"
          placeholder="検索"
          v-model="model.searchText"
          @keydown.enter="$utils.event.strictEnter($event, getImagesFirstPage)"
        />
        <button @click="getImagesFirstPage"><i class="fas fa-search"></i></button>
      </div>
    </div>
    <portal v-if="isShowUploadPopup" to="modal2">
      <upload-popup
        :isLogo="isLogo"
        @close="isShowUploadPopup = false"
        @updateCurrentSize="updateCurrentSize"
        @updatePlanSize="updatePlanSize"
      />
    </portal>
    <portal v-if="!isLogo && isShowMultiUploadPopup" to="modal2">
      <upload-popup
        @close="isShowMultiUploadPopup = false" :isMultiUpload="true"
        @updateCurrentSize="updateCurrentSize"
        @updatePlanSize="updatePlanSize"
      />
    </portal>
    <portal v-if="isShowFolderChipsPopup" to="modal2">
      <chips-popup
        chipType="folder"
        :folders="folders"
        @close="isShowFolderChipsPopup = false"
        @chipSelect="selectFolder($event)"
      />
    </portal>
    <div v-if="!isLogo" class="folders-wrapper">
      <ul
        class="folders"
        :style="{height: folders.height + 'px'}"
        ref="folders"
      >
        <li
          v-for="(folder, index) in sortedFoldersData"
          :class="{ selected: folders.select === folder.id }"
          :key="index"
          @click="selectFolder(folder)"
        >
          <span>{{ folder.name }}</span>
        </li>
      </ul>
      <div
        class="all-open"
        :class="{show: folders.heightAll > 34}"
        @click="isShowFolderChipsPopup = true"
      >
        すべてを表示
      </div>
    </div>
    <div class="operation-area">
      <transition>
      <ul class="batch">
        <li v-if="!isLogo && !isCallByEditor && images.length > 0">
          <input
            id="all-checked"
            type="checkbox"
            @change="check = $event.target.checked"
            :checked="check !== 0 && check === images.length"
          />
          <label for="all-checked"></label>
        </li>
        <li
          v-if="check"
          class="batch-folder normal-btn"
          @click="batchFolderOption = !batchFolderOption"
          v-on-clickaway="batchFolderHidden"
        >
          <span>グループ変更</span>
          <transition>
            <ul class="drop-down-list drop-down-list-scrollable" v-show="batchFolderOption">
              <li> ----- </li>
              <li
                v-for="(folder, index) in folders.data"
                :key="index"
                @click="addFolder(folder)"
              >
                {{ folder.name }}
              </li>
            </ul>
          </transition>
        </li>
        <li
          v-if="check"
          class="delete normal-btn"
          @click="deleteConfirm(false)"
        >
          <span>削除</span>
        </li>
      </ul>
      </transition>
      <div v-if="(!isLogo || (isLogo && isNoImages))" class="upload-button-box" :class="{logo: isLogo}">
        <button @click="isShowUploadPopup = true">
          アップロード
        </button>
      </div>
      <div v-if="!isLogo" class="upload-button-box multi">
        <button @click="isShowMultiUploadPopup = true">
          複数アップロード
        </button>
      </div>
    </div>
    <pagination
      :maxPageIndex="pager.last"
      :currentPageIndex="pager.current"
      @updateCurrentPageIndex="updateCurrentPageIndex"
    />
    <template v-if="!isNoImages">
      <image-view
        :viewMode="viewMode"
        :images="images"
        :isCallByEditor="isCallByEditor"
        :isLogo="isLogo"
        @reflectImage="$emit('reflectImage', $event)"
        @deleteConfirm="deleteConfirm"
        @getImages="getImages"
      />
    </template>
    <template v-else>
      <div class="no-images">
        <p>イメージがありません</p>
      </div>
    </template>
    <pagination
      :maxPageIndex="pager.last"
      :currentPageIndex="pager.current"
      @updateCurrentPageIndex="updateCurrentPageIndex"
    />
    <portal v-if="isShowDeletePopup" to="modal2">
      <modal @close="isShowDeletePopup = false">
        <template slot="title">削除確認</template>
        <template slot="name">画像 {{ deletes.length }} 枚を本当に削除してもよろしいでしょうか?</template>
        <template slot="submit">
          <div class="button-box">
            <button type="button" @click="deleteImages" class="delete  normal-btn">削除</button>
            <button type="button" @click="isShowDeletePopup = false" class="cancel normal-btn">キャンセル</button>
          </div>
        </template>
      </modal>
    </portal>
    <portal v-if="isDeleteLoading" to="modal2">
      <div class="delete-loading">
        <div class="spinner">
          <span>Loading...</span>
        </div>
      </div>
    </portal>
  </div>
</template>

<script>
import UploadPopup from '@/components/ImageManager/UploadPopup'
import ImageView from '@/components/ImageManager/ImageView'
import Modal from '@/components/Util/Modal'
import Pagination from '@/components/Util/Pagination'
import ChipsPopup from '@/components/Contents/ChipsPopup'
import { mixin as onClickAway } from 'vue-clickaway'

const ONE_LINE_HEIGHT = 24
const SORTS = [
  ['code', 'asc'],
  ['code', 'desc'],
  ['name', 'asc'],
  ['name', 'desc'],
  ['modifiedUserName', 'asc'],
  ['modifiedUserName', 'desc'],
  ['modifiedOn', 'asc'],
  ['modifiedOn', 'desc'],
  ['size', 'asc'],
  ['size', 'desc'],
]

const initialData = () => {
  return {
    isShowUploadPopup: false,
    isShowMultiUploadPopup: false,
    isShowSortSelect: false,
    isShowDeletePopup: false,
    isShowFolderChipsPopup: false,
    isCheckMode: false,
    isNoImages: false,
    searchText: null,
    viewMode: 'tile',
    batchFolderOption: false,
    pager: {
      current: 1,
      last: 1,
    },
    model: {
      searchText: null,
    },
    images: [],
    deletes: [],
    isDeleteLoading: false,
    currentSize: 0,
    planSize: 0,
    sort: {
      index: 5,
      target: 'modifiedOn',
      type: 'desc',
    },
    folders: {
      data: [],
      select: 'all',
      height: ONE_LINE_HEIGHT,
      heightAll: 0,
    },
  }
}
export default {
  props: [
    'isCallByEditor',
    'isLogo', // routerとImageManagerPopup 呼び出しで設定
  ],
  mixins: [onClickAway],
  components: {
    UploadPopup,
    ImageView,
    Modal,
    Pagination,
    ChipsPopup,
  },
  data () {
    return initialData()
  },
  computed: {
    check: {
      get: function () {
        return this.images.filter(image => (image.checked)).length
      },
      set: function (value) {
        this.images.forEach(image => { image.checked = value })
      }
    },
    imageDetailEditor () {
      return this.$store.state.status.imageDetailEditor
    },
    sortedFoldersData () {
      // グループ名が 未設定 > 選択されている > 選択されていない の順番でソートしています
      const [ unsetFoldersData, ...notUnsetFoldersData ] = this.folders.data
      const selectedFolders = notUnsetFoldersData.filter(folder => this.folders.select === folder.id)
      const notSelectedFolders = notUnsetFoldersData.filter(folder => this.folders.select !== folder.id)

      return unsetFoldersData == null ? [
        ...selectedFolders,
        ...notSelectedFolders,
      ] : [
        unsetFoldersData,
        ...selectedFolders,
        ...notSelectedFolders,
      ]
    },
  },
  mounted () {
    this.initComponent()
  },
  methods: {
    initComponent () {
      this.$store.watch(
        state => state.images,
        state => {
          this.images = state.map(image => {
            return {
              ...image,
              checked: false,
              showInput: {
                name: false,
                alt: false,
              }
            }
          })
          this.isNoImages = (this.images.length === 0)
        }
      )
      this.getDefaultDisplay().then(() => this.getImagesFirstPage())
      // ロゴの時はグループは読み込まない
      !this.isLogo && this.getFolders()
    },
    getDefaultDisplay () {
      return this.$http({
        url: '/user/mphe_settings/default_display_' + (this.isLogo ? 'image_logo' : 'image'),
        type: 'GET',
      }).then(json => {
        if (json && json.status === 200) {
          const { viewMode, sortTarget, sortType, grepFolder } = json.data.display
          if (this.isCallByEditor) {
            // エディターからのポップアップはタイル表示のみ
            this.viewMode = 'tile'
          } else {
            this.viewMode = viewMode
          }
          if (!this.isLogo) {
            this.sort = {
              index: SORTS.findIndex(sort => sort[0] === sortTarget && sort[1] === sortType),
              target: sortTarget,
              type: sortType
            }
            this.folders.select = grepFolder || 'all'
          }
        }
        return json
      })
    },
    updateCurrentPageIndex (index) {
      if (index > this.pager.total || index < 1) return
      this.pager.current = index
      this.getImages()
    },
    sortSelectAway () {
      this.isShowSortSelect = false
    },
    changeSort (index, target, type) {
      this.isShowSortSelect = false
      this.sort = { index, target, type }
      this.getImagesFirstPage()

      // 並び替え設定を保存
      const formData = new FormData()
      formData.append('imageSortTarget', target)
      formData.append('imageSortType', type)
      this.$http({
        url: '/user/mphe_settings/change_default_display',
        type: 'POST',
        params: formData,
      })
    },
    changeViewMode () {
      this.viewMode = this.viewMode === 'tile' ? 'list' : 'tile'

      // タイル or リスト 表示設定を保存
      const formData = new FormData()
      if (this.isLogo) {
        formData.append('imageLogoViewMode', this.viewMode)
      } else {
        formData.append('imageViewMode', this.viewMode)
      }
      this.$http({
        url: '/user/mphe_settings/change_default_display',
        type: 'POST',
        params: formData,
      })
    },
    getImages () {
      const urlSP = new URLSearchParams()
      urlSP.append('searchText', this.model.searchText == null ? '' : this.model.searchText)
      urlSP.append('sortTarget', this.sort.target)
      urlSP.append('sortType', this.sort.type)
      urlSP.append('folder', this.folders.select)
      urlSP.append('flgLogo', this.isLogo ? 1 : 0)
      urlSP.append('page', this.pager.current)
      const isLogo = this.isLogo
      return this.$http({
        url: `/image?${urlSP.toString()}`,
        type: 'GET',
      }).then(json => {
        if (isLogo !== this.isLogo) return // ロゴ切り替え時に前のリクエストを無視する
        if (json && json.status === 200) {
          const images = json.data.images.map(image => {
            return {
              ...image,
              url: decodeURIComponent(image.url),
              thumbnailUrl: decodeURIComponent(image.thumbnailUrl),
            }
          })
          this.isNoImages = (images.length === 0)
          this.updateCurrentSize(json.data.currentSize)
          this.planSize = json.data.planSize
          this.pager.last = json.data.lastPage
          this.$store.commit('updateImages', images)
        }
      })
    },
    getImagesFirstPage () {
      this.pager.current = 1
      this.getImages()
    },
    deleteConfirm (image = false) { // 明示的に指定
      // 単体で削除 or チェックボックスで選択
      this.deletes = image ? [ image ] : this.images.filter(image => (image.checked))
      this.isShowDeletePopup = true
    },
    deleteImages () {
      const formData = new FormData()
      this.deletes.map(image => {
        formData.append('deleteKeys[]', image.key)
        return image.id
      })
      this.isDeleteLoading = true
      this.$http({
        url: '/image/delete',
        type: 'POST',
        params: formData
      }).then(json => {
        if (json && json.status === 200) {
          this.getImages().then(() => {
            if (this.pager.current > this.pager.last) {
              // 現在のページが最後のページより後ろなら前のページに戻る
              this.pager.current--
              this.getImages()
            }
          })
        }
        this.deletes = []
        this.isShowDeletePopup = false
        this.isDeleteLoading = false
      })
    },
    batchFolderHidden () {
      this.batchFolderOption = false
    },
    getFolders () {
      return this.$http({
        url: `/folder/image?sortTarget=manual&sortType=asc`,
        type: 'GET',
      }).then(json => {
        if (json && json.status === 200) {
          this.folders.data = [
            {
              id: 'unset',
              name: '未設定',
            },
            ...json.data.folders.map(folder => {
              return {
                ...folder,
                name: this.$utils.string.b64Decode(folder.name),
              }
            })
          ]
          this.$nextTick(() => {
            if (!this.$refs.folders) return
            this.folders.heightAll = this.$refs.folders.scrollHeight
          })
        }
      })
    },
    addFolder (folder) {
      const formData = new FormData()
      this.images.filter(image => (image.checked)).map(image => {
        formData.append('targetIds[]', image.id)
      })
      formData.append('folder', folder.id)
      this.$http({
        url: '/folder/add/image',
        type: 'POST',
        params: formData
      }).then(json => {
        if (json && json.status === 200) {
          this.getImagesFirstPage()
        }
      })
    },
    selectFolder (folder) {
      if (this.folders.select === folder.id) {
        // 同じグループが選ばれた場合はグループ選択を解除する
        this.folders.select = 'all'
      } else {
        // グループ絞り込み
        this.folders.select = folder.id
      }
      this.getImagesFirstPage()
    },
    updateCurrentSize (size) {
      this.currentSize = Math.ceil(size * 100) / 100
    },
    updatePlanSize (size) {
      this.planSize = size
    },
  },
  watch: {
    imageDetailEditor (value) {
      const { show, newImage } = value
      // 新しい画像保存時
      if (newImage && newImage.url && !show) {
        this.getImages().then(() => {
          let currentSize = 0
          this.images.forEach(image => {
            currentSize += image.size
          })
          this.updateCurrentSize(currentSize)
        })
      }
    },
    searchImages (value) {
      this.getImagesFirstPage()
    },
    isLogo (value) {
      // isLogo 変更時、初期化する
      Object.assign(this.$data, initialData())
      this.initComponent()
    }
  }
}
</script>

<style lang='scss' scoped>
.image-manager {
  font-size: 14px;
  position: relative;
  h2 {
    padding-left: 20px;
    margin-bottom: 50px;
    font-size: 24px;
    color: rgba($baseFontColor, 0.9);
    span {
      color: rgba($baseFontColor, 0.6);
      font-size: 12px;
      display: inline-block;
      padding: 0 8px;
      margin-left: 8px;
      height: 22px;
      line-height: 22px;
      border-radius: 13px;
      background: #e4e4e4;
    }
  }
  .sub-header {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-end;
    position: absolute;
    top: 0;
    right: 0;
    width: 420px;
    .normal-btn {
      margin-bottom: 20px;
    }
    .search {
      width: 400px;
      height: 35px;
      margin-right: 20px;
      display: block;
      position: relative;
      &>input {
        width: 100%;
        padding:0 10px;
        border-radius:2px;
        height: 35px;
        outline:0;
        background: #E4E4E4;
        position: absolute;
        left: 0;
        top: 0;
        &::-webkit-input-placeholder {
          position: relative;
          top: 0.05em;
        }
      }
      &>button {
        width: 50px;
        height: 35px;
        border-radius:0 2px 2px 0;
        outline:0;
        position: absolute;
        right: -20px;
        top: 0;
        background: none;
        transition: all 0.3s ease 0s;
        cursor: pointer;
        &:hover, &:active {
          background: #c6c6c6;
          transition: all 0.3s ease 0s;
        }
      }
    }
    .sort {
      &::before {
        content: '\f161';
        font-family: "Font Awesome 5 Free";
        font-weight: 900;
      }
      .sort-option {
        right: 0;
        width: 83px;
        li {
          position: relative;
          width: 100%;
          &.selected::before {
            content: '\f00c';
            font-family: "Font Awesome 5 Free";
            font-weight: 900;
            position: absolute;
            top: 0;
            left: -15px;
          }
        }
      }
    }
    .display-type {
      &::before {
        font-family: "Font Awesome 5 Free";
        font-weight: 900;
      }
      &.tile {
        &::before {
          content: '\f00a';
          padding-right: 4px;
        }
      }
      &.list {
        &::before {
          content: '\f03a';
        }
      }
    }
  }
  // フォルダへのリンク
  .folders-wrapper {
    display:-webkit-box;
    display:flex;
    margin: 0 0 25px 20px;
    .folders {
      margin-top: 10px;
      display:-webkit-box;
      display: flex;
      flex-wrap: wrap;
      transition: all 0.3s ease 0s;
      overflow: hidden;
      &::before {
        font-family: "Font Awesome 5 Free";
        content: '\f5fd';
        font-weight: 900;
      }
      li {
        height: 24px;
        line-height: 24px;
        display: inline-block;
        padding: 0 10px;
        cursor: pointer;
        margin: 0 10px 10px 0;
        background: #fff;
        border-radius: 2px;
        transition: all 0.3s ease 0s;
        &:first-of-type {
          margin-left: 10px;
        }
        &:hover {
          background: rgba($primaryHoverColor, 0.4);
        }
        &.selected {
          color: #fff;
          background: $primaryActiveColor;
          &:hover {
            background: $primaryHoverColor;
          }
        }
      }
    }
  }
  // すべてを表示 ボタン
  .all-open {
    height: 24px;
    margin-top: 10px;
    line-height: 24px;
    font-size: 12px;
    display: inline-block;
    padding: 0 10px;
    flex-shrink: 0;
    border-radius: 12px;
    transition: all 0.3s ease 0s;
    cursor: pointer;
    visibility: hidden;
    &::before {
      font-family: "Font Awesome 5 Free";
      content: '\f022';
      font-weight: 900;
    }
    &.show {
      visibility: visible;
    }
    &:hover, &:active {
      background: #e4e4e4;
      transition: all 0.3s ease 0s;
    }
  }
  // 一括操作・検索・表示型切り替えボタン
  .operation-area {
    height: 35px;
    margin-bottom: 10px;
    position: relative;
    // 一括操作のチェックボックス
    input[type=checkbox] {
      display:  none;
      + label {
        font-size: 12px;
        margin-bottom: 0;
        display: inherit;
        line-height: 20px;
        &::before {
          width: 20px;
          height: 20px;
          vertical-align: bottom;
          margin-right: 8px;
          display: inline-block;
          content: '';
          border-radius: 4px;
          background: #cfcfcf;
        }
      }
      &:checked + label::before {
        font-size: 14px;
        box-sizing: border-box;
        font-family: "Font Awesome 5 Free";
        padding-left: 3px;
        content: '\f00c';
        display: inline-block;
        font-weight: 900;
      }
    }
    .batch {
      display:flex;
      margin: 0 0 0 20px;
      li:not(:first-of-type) {
        span {
          display: inline-block;
          &::before, &::after {
            font-family: "Font Awesome 5 Free";
            font-weight: 900;
          }
          &::before {
            padding-right: 5px;
          }
        }
        &.batch-folder {
              width: auto;
          &::after {
            font-family: "Font Awesome 5 Free";
            font-weight: 900;
            content: '\f107';
            padding-left: 5px;
          }
          span::before {
            content: '\f5fd';
          }
        }
        &.delete {
          width: 80px;
          span::before {
            content: '\f2ed';
          }
        }
      }
      > li:first-of-type {
        padding: 7.5px 0;
      }
      // ドロップダウンリストクリック時のアニメーション
      .v-enter-active, .v-leave-active {
        transition: all .1s;
      }
      .v-enter,.v-leave-to {
        height: 0;
        opacity: 0;
      }
      .v-enter-to, .v-leave {
        height: 152px;
        opacity: 1;
      }
      // チェックボックスにチェック時のアニメーション
      &.v-enter-active, &.v-leave-active {
        transition: opacity .1s ease-in-out;
      }
      &.v-enter, &.v-leave, &.v-leave-to {
        opacity: 0;
      }
      &.v-enter-to{
        opacity: 1;
      }
    }
  }
  // アップロードボタン
  .upload-button-box {
    display: inline-block;
    overflow: hidden;
    box-sizing: border-box;
    border-radius: 5px;
    position: absolute;
    top: 0;
    left: 270px;
    transition: background 0.3s ease 0s;
    cursor: pointer;
    &.logo  {
      left: 20px;
    }
    &.multi {
      left: 415px;
    }
    &:hover, &:active {
      background: #e4e4e4;
      overflow: hidden;
      transition: background 0.3s ease 0s;
    }
    button {
      color: #fff;
      border: none;
      height: 30px;
      line-height: 30px;
      padding: 0;
      background: $primaryColor;
      white-space: nowrap;
      text-align: center;
      font-size: 12px;
      cursor: pointer;
      user-select: none;
      padding: 0 15px;
      &::before {
        padding-right: 8px;
        font-size: 14px;
        content: '\f574';
        font-family: "Font Awesome 5 Free";
        font-weight: 900;
      }
      &:hover {
        background: $primaryHoverColor;
      }
      &:active {
        background: $primaryActiveColor;
      }
      &:focus {
        outline:0;
      }
    }
  }:where
  // タイル表示のときだけ横並び
  .tile {
    display:-webkit-box;
    display:flex;
    flex-wrap: wrap;
  }
  // 表示型切り替えボタンクリック時のアニメーション
  .v-enter-active {
    transition: opacity .3s ease-in-out;
  }
  .v-enter, .v-leave, .v-leave-to {
    opacity: 0;
  }
  .v-enter-to{
    opacity: 1;
  }
  .no-images {
    width: 100%;
    height: 200px;
    display: flex;
    justify-content: center;
    align-items: center;
    p {
      font-size: 14px;
    }
  }
}
.delete-loading {
  z-index: 10;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.8);
}

// モーダルの中身
.button-box {
  display: flex;
  justify-content: center;
  button {
    font-size: 14px;
    border: solid 1px #c6c6c6;
    border-radius: 5px;
    &:hover {
      opacity: 0.8;
    }
    &.delete {
      margin-right: 20px;
      color: #fff;
      border: solid 1px #484848;
      background: #484848;
    }
  }
}
</style>
